import { Stack } from "@mui/material";
import type { StorageLocationView } from "adl-gen/ferovinum/app/api";
import { CardWithTitle } from "./card-with-title";
import { LocationInput } from "./localtion-input";

export const StorageLocationCard = ({
  activeStorageLocation,
  storageLocations,
  onChangeLocation,
}: {
  activeStorageLocation: StorageLocationView;
  storageLocations: StorageLocationView[];
  onChangeLocation: (v: StorageLocationView | null) => void;
}) => {
  return (
    <CardWithTitle
      title="Storage Location"
      subtitle="Please select the storage location from where your products are to be sold."
      body={
        <Stack spacing={2}>
          <LocationInput
            selectedLocation={activeStorageLocation}
            locations={storageLocations}
            onChange={onChangeLocation}
          />
        </Stack>
      }
    />
  );
};
